const CurrencyState = {
    currencies: [],
};

export default CurrencyState;